angular.module('bribac.components.imageMultiSelect', [
  'bribac.translations'
])

  .component('imageMultiSelect', {
    templateUrl: 'image-multi-select-component.html',
    controller: 'ImageMultiSelectComponentCtrl',
      bindings: {
          images: '=',
          callback: '<',
      }
  })

  .controller('ImageMultiSelectComponentCtrl', function() {
      var $ctrl = this

      $ctrl.toggleImage = function (imageToToggle) {
          imageToToggle.isChecked = !imageToToggle.isChecked
          $ctrl.callback($ctrl.images)
      }

      $ctrl.unselectAllImages = function () {
          $ctrl.images.forEach(function (img) {
              img.isChecked = false;
          });
          $ctrl.callback($ctrl.images)
      }

      $ctrl.selectAllImages = function () {
          $ctrl.images.forEach(function (img) {
              img.isChecked = true;
          });
          $ctrl.callback($ctrl.images)
      }

  })
